import type { CardsAction, ICardsSearchParams } from '@Actions/cardsActions';
import {
  ADD_CAPABILITIES,
  ADD_CARD_PROGRAM,
  CARDS_SET_LOADING,
  CARD_PROGRAMS_SET_LOADING,
  REMOVE_CARD_PROGRAM,
  SET_CARDS,
  SET_CARDS_SEARCH_PARAMS,
  SET_CARD_PROGRAM,
  SET_CARD_PROGRAMS,
  SET_CARD_PROGRAM_CARD_COUNTS
} from '@Actions/cardsActionsConstants';

import { ProgramCardCounts } from '@ClientServices/api/linkedAccounts';
import { DEFAULT_DATA_GRID_LIMIT, IPaginationParams } from '@Shared/grid';
import { AccountCapabilities } from '@Shared/interfaces';
import { ILinkedAccountModel } from '@Shared/models';

interface ICardsState {
  programs: ILinkedAccountModel[];
  capabilities: Record<string, AccountCapabilities>;
  loading: boolean;
  loaded: boolean;

  counts: ProgramCardCounts;

  cards: ILinkedAccountModel[];
  cardsTotal: number;
  cardsPaginationParams: IPaginationParams;
  searchParams: ICardsSearchParams;
  cardsLoading: boolean;
}

export const defaultState: ICardsState = {
  programs: [],
  capabilities: {},
  loading: false,
  loaded: false,

  counts: {},

  cards: [],
  cardsTotal: 0,
  cardsPaginationParams: {
    page: 0,
    pageSize: DEFAULT_DATA_GRID_LIMIT,
    sortField: 'created_at',
    sortDirection: 'desc',
    filters: {},
    search: ''
  },
  searchParams: {},
  cardsLoading: true
};

export function cardsReducer(state: ICardsState = defaultState, action: CardsAction): ICardsState {
  switch (action.type) {
    case SET_CARD_PROGRAMS:
      return { ...state, programs: action.payload, loaded: true };
    case SET_CARD_PROGRAM:
      return {
        ...state,
        programs: state.programs.map((program) => (program.id === action.payload.id ? action.payload : program)),
        loading: false
      };
    case ADD_CARD_PROGRAM:
      return {
        ...state,
        programs: [...state.programs, action.payload],
        loading: false
      };
    case SET_CARDS:
      return {
        ...state,
        cards: action.payload.cards,
        cardsTotal: action.payload.total,
        cardsPaginationParams: action.payload.paginationParams
      };
    case SET_CARDS_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: action.payload
      };
    case REMOVE_CARD_PROGRAM:
      return {
        ...state,
        programs: state.programs.filter((program) => program.id !== action.payload)
      };
    case SET_CARD_PROGRAM_CARD_COUNTS:
      return {
        ...state,
        counts: action.payload
      };
    case ADD_CAPABILITIES:
      return {
        ...state,
        capabilities: {
          ...state.capabilities,
          ...action.payload
        }
      };
    case CARD_PROGRAMS_SET_LOADING:
      return { ...state, loading: action.payload };
    case CARDS_SET_LOADING:
      return { ...state, cardsLoading: action.payload };
    default:
      return state;
  }
}
